/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum UpdateMediaErrorCode {
    Unknown = 0,
    FileNullOrEmpty = 1,
    DescriptionNullOrEmpty = 2,
    ExtentionInvalid = 3,
    CouldNotConvertAudio = 4,
    DuplicateFileName = 5,
    CouldInReplace = 6,
    ErrorInUpdate = 7,
}
